export const displayModelId = (name) => String(name || '').replace(/^cos\//i, '');
